import { render } from "./ApprovedStartDateField.vue?vue&type=template&id=2aa6161f"
import script from "./ApprovedStartDateField.vue?vue&type=script&lang=js"
export * from "./ApprovedStartDateField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__